import React, { Component } from 'react';
//import ReactDOM from 'react-dom';
//import { Router, Route, browserHistory, IndexRoute } from 'react-router';
//import {Link} from 'react-router-dom';
import ArticleGeneric from './article-generic.jsx';

class Main extends Component {
    render() { 
        return ( 
        <div className="widewrapper main">
            <div className="container">
                <div className="row">
                    <div className="col-md-8 blog-main">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <article className="blog-teaser">
                                    <header>
                                        <img src={require('../assets/img/Christmas/christmasgreetings.jpg')} className="img-fluid" alt="Merry Christmas 2025" style={{maxWidth: '100%', height: 'auto', borderRadius: '8px'}} />
                                        <h3>
                                            <a href="/Christmas2025">Merry Christmas 2025</a>
                                        </h3>
                                        <hr />
                                    </header>
                                    <div className="body">
                                        Celebrating the holiday season with reflections on physics, mathematics, and computer science.
                                    </div>
                                    <div className="clearfix">
                                        <a href="/Christmas2025" className="btn btn-tales-one">Read more</a>
                                        <br/><br/>
                                    </div>
                                </article>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 col-sm-6">
                                <ArticleGeneric ImageName="golang" ReadMoreTo="Golang" ReadMoreToText="Golang" Body="Golang, built for Docker, k8s, and microservices...."></ArticleGeneric>
                                </div>
                                <div className="col-md-6 col-sm-6">
                                <ArticleGeneric ImageName="k8s" ReadMoreTo="DockerKubernetes" ReadMoreToText="Docker and Kubernetes" Body="K8s and microservices are the future of the enterprise..."></ArticleGeneric>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 col-sm-6">
                                <ArticleGeneric ImageName="dockerlogo" ReadMoreTo="Docker" ReadMoreToText="Containerization and .Net Core" Body=""></ArticleGeneric>
                                </div>
                                <div className="col-md-6 col-sm-6">
                                <ArticleGeneric ImageName="strumia" ReadMoreTo="Strumia" ReadMoreToText="The Alessandro Strumia Affair" Body=""></ArticleGeneric>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                            <article className="blog-teaser">
                                <header>
                                    <img src={require('../assets/img/flag.jpg')} alt="flag"/>
                                        <h3>
                                            <a href="https://www.youtube.com/watch?v=H2xxBmoaBDM" target="_blank" rel="noopener noreferrer">Remember</a>
                                        </h3>
                                        <hr/>
                                        September 11, 2018
                                    <br/>
                                    <br/>
                                </header>
                            </article>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 col-sm-6">
                                <ArticleGeneric ImageName="gauss" ReadMoreTo="ComplexNumbers" ReadMoreToText="Complex Numbers" Body="Our ultimate goal is to explain, simply, how the classical idea of a bit -- something that can have a value of only zero or one -- may be extended to a quantum system. Because quantum mechanics uses 'complex numbers', it is natural to start there... "></ArticleGeneric>
                                </div>
                                <div className="col-md-6 col-sm-6">
                                <ArticleGeneric ImageName="dirac" ReadMoreTo="QuantumBits" ReadMoreToText="Quantum Bits" Body="The quantum analog of a two valued sytem gives rise to the idea of a quantum bit, also known as a qubit."></ArticleGeneric>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 col-sm-6">
                                <ArticleGeneric ImageName="boole2" ReadMoreTo="BitsAndAllThat" ReadMoreToText="Bits, Quantum Bits, And All That"
                                 Body="Bits are familiar to many. Quantum bits (or qubits) are perhaps not so well known. They are neeeded for quantum computation, so we will take a look...  "></ArticleGeneric>
                                </div>
                                <div className="col-md-6 col-sm-6">
                                <ArticleGeneric ImageName="foleybook" ReadMoreTo="FoleyRotation" ReadMoreToText="Computer Graphics, Rotations, and lazy Professors"
                                 Body="A standard text on computer graphics is 'Introduction to Computer Graphics' by Foley, Van Dam, Feiner, Hughes, and Phillips. Even though it was published... "></ArticleGeneric>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 col-sm-6">
                                <ArticleGeneric ImageName="angular" ReadMoreTo="Angular" ReadMoreToText="Angular 6" 
                                Body="This site has been converted to Angular 6"></ArticleGeneric>
                                </div>
                                <div className="col-md-6 col-sm-6">
                                <ArticleGeneric ImageName="orion" ReadMoreTo="Orion" ReadMoreToText="Orion and Mars" Body="Sometime ago, NASA launched its Orion rocket, with the goal of sending man to Mars. A cost and benefit analysis is interesting... "></ArticleGeneric>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 col-sm-6">
                                <ArticleGeneric ImageName="magrealitybw" ReadMoreTo="Magic" ReadMoreToText="Magic of Reality Review" 
                                Body="A review of Dawkins' work that he wrote for a younger audience. A careful analysis of Dawkins' work is given. Dawkins' book utlimately turned out to be a missed opportunity for Dawkins."></ArticleGeneric>
                                </div>
                                <div className="col-md-6 col-sm-6">
                                
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
             );
    }
}
 
export default Main;